// 查重
import {SDrawerOrModal, SLowcodeList, STriggerModal} from 'shj-components';
import {checkRepeatByPhone} from "@/services/saleOpServices.ts";

function DuplicatedModal(props: any) {
  const { open, onCancel } = props;
  const columns: any[] = [
    {
      title: '线索ID',
      dataIndex: 'id',
      width: 200,
      fixed: 'left',
    },
    {
      title: '电话号码',
      dataIndex: 'phone',
      width: 120,
    },
    {
      title: '渠道',
      dataIndex: 'channelName',
      width: 200,
      ellipsis: true,
    },
    {
      title: '云客服',
      dataIndex: 'seatName',
      width: 160,
    },
    {
      title: '云客服部门',
      dataIndex: 'seatDeptName',
      width: 160,
    },
    {
      title: '营销部门',
      dataIndex: 'salesDeptName',
      width: 140,
    },
    {
      title: '营销员',
      dataIndex: 'salesName',
      width: 100,
    },
    {
      title: '派单时间',
      dataIndex: 'dispatchTime',
      width: 200,
      itemType: 'dateTime'
    },
    {
      title: '线索状态',
      dataIndex: 'statusName',
      width: 140,
    },
    {
      title: '最近跟进时间',
      dataIndex: 'lastFollowTime',
      width: 200,
      itemType: 'dateTime'
    },
  ];

  const fetchList = ({query}) => {
    if(!query.phone) return Promise.reject()
    return new Promise((resolve, reject) => {
      checkRepeatByPhone(query.phone).then(res => {
        resolve({records: res})
      }).catch (() => {
        reject({ success: false });
      })
    })
  };

  return (
    <SDrawerOrModal
      title="查重列表"
      width={1000}
      open={open}
      onCancel={onCancel}
      antdProps={{footer: null}}
    >
      <SLowcodeList
          key={'searchRepeat'}
          searchMode={'group'}
          config={{
            columns,
            fieldControl: false,
            rowSelection: false,
            pagination: false,
            search: [{
              label: '客户电话',
              name: 'phone'
            }]
          }}
          request={{fetchList}}
      />
    </SDrawerOrModal>
  );
}

export default DuplicatedModal;
